export default __webpack_public_path__ + "static/media/a03b803116d5c69366011cc7a84de4f0.3bf098d0.svg";